import i18n from 'i18n-js';

import translation from './translation';

i18n.translations = translation;

i18n.locale = i18n.currentLocale() || 'en';
i18n.fallbacks = true;
i18n.defaultSeparator = '*';

i18n.missingTranslation = function (t) {
  return t;
};
